<template>
  <div>
    <div class="vx-row">
      <!-- MULTIPLE COLUMNS-->
      <div class="vx-col w-full mb-base">
        <vx-card title="">
          <div class="">
            <b-row class="justify-content-md-start">
              <b-col cols="12" md="auto">
                <div
                  :class="{ activeLoading: activeLoading }"
                  v-for="type in types"
                  :key="type"
                  :id="[`loading-${type}`]"
                  style="width: 35px !important; height: 35px !important;"
                  class="vs-con-loading__container loading-example"
                ></div>
              </b-col>
              <b-col cols="12" md="auto">
                <b-form-group label-for="item-name">
                  <b-button
                    style="background-color:#28C76F; border-color:#28C76F;"
                    v-on:click="siparisCek(0)"
                    ><Icon
                      style="margin-right: 5px"
                      icon="mdi:source-pull"
                      width="20"
                      height="20"
                    />Sipariş Çek</b-button
                  >
                </b-form-group>
              </b-col>
              <b-col cols="12" md="auto" style="padding-left: 0px !important;">
                <b-button
                  style="background-color: #EA5455; border-color:#EA5455;"
                  v-on:click="siparisListesi()"
                  ><Icon
                    style="margin-right: 5px"
                    icon="material-symbols:list-alt-outline"
                    width="20"
                    height="20"
                  />Sipariş Listele</b-button
                ></b-col
              >
              <b-col cols="12" md="auto" style="padding-left: 0px !important;">
                <b-button
                  style="background-color: #FF9F43; border-color:#FF9F43;"
                  v-on:click="siparisKontrol()"
                  ><Icon
                    style="margin-right: 5px"
                    icon="ant-design:control-outlined"
                    width="20"
                    height="20"
                  />Sipariş Kontrol</b-button
                ></b-col
              >
            </b-row>
          </div>
        </vx-card>
        <vx-card title=""> </vx-card>
      </div>
      <div class="vx-col lg:w-4/4 w-full relative">
        <vs-card>
          <b-row class="justify-content-md-start" style="margin-bottom: 10px;">
            <b-col cols="3">
              <b-form-group label-for="item-name">
                <b-form-input
                  v-model="aranan"
                  id="smallInput"
                  placeholder="Ara.."
                  @keyup.enter="tamamlananSiparis"
                  size="sm"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="auto" style="padding-left: 0px !important;">
              <b-button
                style="background-color: #7367F0; border-color:white;"
                size="sm"
                v-on:click="tamamlananSiparis()"
                ><Icon
                  icon="material-symbols:search-rounded"
                  width="20"
                  height="20"/></b-button
            ></b-col>
          </b-row>
          <vs-table stripe :data="siparisList">
            <template slot="thead">
              <vs-th sort-key="orderNumber">Sipariş No</vs-th>
              <vs-th sort-key="invoiceFirstName">Adı Soyadı</vs-th>
              <vs-th sort-key="cargoTrackingNumber">Kargo No</vs-th>
              <vs-th sort-key="grossAmount">Tutar</vs-th>
              <vs-th sort-key="siparisAdetleri">Parca Adedi</vs-th>
              <vs-th sort-key="shipFullName">Teslimat Adı</vs-th>
              <vs-th sort-key="stokkodu">Sipariş Tarihi</vs-th>
              <vs-th sort-key="sipdurumm">Durum</vs-th>
              <vs-th></vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].orderNumber">
                  {{ data[indextr].orderNumber }}
                </vs-td>
                <vs-td :data="data[indextr].invoiceFirstName">
                  {{ data[indextr].invoiceFirstName }}
                  {{ data[indextr].invoiceLastName }}
                </vs-td>
                <vs-td :data="data[indextr].cargoTrackingNumber">
                  {{ data[indextr].cargoTrackingNumber }}
                </vs-td>

                <vs-td :data="data[indextr].grossAmount">
                  {{ data[indextr].grossAmount }}
                </vs-td>

                <vs-td :data="data[indextr].siparisAdetleri">
                  {{ data[indextr].siparisAdetleri }}
                </vs-td>
                <vs-td :data="data[indextr].shipFullName">
                  {{ data[indextr].shipFullName }}
                </vs-td>
                <vs-td :data="data[indextr].siparisTarihi">
                  {{ data[indextr].siparisTarihi }}
                </vs-td>

                <vs-td :data="data[indextr].sipdurumm">
                  <div v-if="parseInt(data[indextr].sipdurumm) > 0">
                    <Icon
                      icon="material-symbols:check-circle"
                      color="#28c76f"
                      width="25"
                      height="25"
                    />
                  </div>
                </vs-td>
                <vs-td>
                  <b-button
                    variant="outline-light"
                    v-on:click="siparisDetay(data[indextr].orderNumber)"
                    size="sm"
                    ><Icon
                      icon="majesticons:checkbox-list-detail-line"
                      width="25"
                      height="25"
                      v-b-tooltip.hover.bottom="'DETAY'"
                      color="#7367F0"
                  /></b-button>
                </vs-td>
              </vs-tr>
              <vs-tr> </vs-tr>
            </template>
          </vs-table>
        </vs-card>
      </div>
    </div>
    <xmlSiparisDetayButon ref="siparisCek" />
  </div>
</template>

<script>
import state from "../../store/state";
import Store from "../../store/store";
import SiparisExcel from "../components/uzum-components/pazaryeri-components/SiparisExcel.vue";
import xmlSiparisDetayButon from "../components/uzum-components/pazaryeri-components/xmlSiparisDetayButon.vue";
import { Icon } from "@iconify/vue2";
export default {
  data() {
    return {
      types: ["material"],
      activeLoading: false,
      pazaryer: "Ticimax",
      siparisList: [],
      aranan: "",
      sayfaListe: 0
    };
  },
  components: {
    Icon,
    SiparisExcel,
    xmlSiparisDetayButon
  },
  created() {
    this.siparisCek(0);
  },

  methods: {
    
    siparisListesi() {
      this.tamamlananValidated = true;

      this.validated1 = true;
      this.validated = false;
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        pazaryeri: "Ticimax",
        token: Store.state.tokenId,
        sayfa: 99
      };
      soap.createClient(url, function(err, client) {
        client.siparisListele(args, function(err, result) {
          if (result.siparisListeleResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.siparisListeleResult);
          vm.siparisList = vm.veriler;
          vm.$vs.loading.close("#loading-material > .con-vs-loading");
        });
      });
    },
    siparisKontrol() {
      this.siparisKontrolBasildimi = 1;
      this.validated1 = true;
      this.validated = false;
      const vm = this;
      var vs = this.$vs;
      vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#button-with-loading-control",
        scale: 0.45
      });

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = { program: "Ticimax", token: Store.state.tokenId };
      soap.createClient(url, function(err, client) {
        client.siparisKontrol(args, function(err, result) {
          if (result.siparisKontrolResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.siparisKontrolResult);
            vm.list = vm.veriler;

            vs.loading.close("#button-with-loading-control > .con-vs-loading");
            vs.notify({
              title: "Ticimax",
              text: "Siparişler Kontrol Edildi",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center"
            });
          } catch (error) {
            vs.loading.close("#button-with-loading-control > .con-vs-loading");

            vs.notify({
              title: "Ticimax",
              text: "Siparişler Kontrol Edilirken Hata Oluştu",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center"
            });
          }
        });
      });
    },
    siparisDetay(orderNumber) {
      var vm = this;
      vm.veriler = [];
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        pazaryeri: "Ticimax",
        orderNumber: orderNumber,
        sayfa: vm.sayfaListe
      };
      soap.createClient(url, function(err, client) {
        client.siparisListele(args, function(err, result) {
          if (result.siparisListeleResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.siparisListeleResult);
          vm.$refs.siparisCek.siparisDetayCek(vm.veriler, "Ticimax");

          if (vm.veriler.response == "Ok") {
            // alert("ok")
          } else {
            //alert("Veriler Çekilemedi");
          }
        });
      });
    },

    siparisCek(sayfasayisi) {
      var vs = this.$vs;
      const vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        pazaryeri: "Ticimax",
        siparisDurumu: 0,
        listelenecekSayfa: sayfasayisi,
        token: Store.state.tokenId
      };
      soap.createClient(url, function(err, client) {
        client.pazaryeriSiparisCek(args, function(err, result) {
          if (result.pazaryeriSiparisCekResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.pazaryeriSiparisCekResult);
            // alert(vm.veriler.response)

            if (vm.veriler.response == "Ok") {
              if (parseInt(sayfasayisi) < parseInt(vm.veriler.totalPages)) {
                vm.veriler.page = parseInt(sayfasayisi) + 1;
                const percent = 100 / parseInt(vm.veriler.totalPages);
                vm.progress = percent * vm.veriler.page;
                //   alert(vm.veriler.page)
                vm.siparisCek(vm.veriler.page);
              } else {
                setTimeout(function() {
                  vs.loading.close(
                    "#button-with-loading-yeni > .con-vs-loading"
                  );
                }, 1000);

                vs.notify({
                  title: "Ticimax",
                  text: "Siparişler Çekildi",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                  position: "top-center"
                });
                vm.siparisListesi();
              }
            } else {
              setTimeout(function() {
                vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
              }, 1000);

              vs.notify({
                title: "Ticimax",
                text: vm.veriler.mesaj,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning",
                position: "top-center"
              });
              vm.siparisListesi();
            }
          } catch (error) {
            vm.siparisListesi();

            setTimeout(function() {
              vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
            }, 1000);
            vs.notify({
              title: "Ticimax",
              text: "Siparişler Çekilemedi",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center"
            });
          }
        });
      });
    },
    siparisYaz() {
      var vm = this;
      var vs = this.$vs;

      vs.loading({
        background: "#015210",
        color: this.colorLoading,
        container: "#button-with-loading-TopluKaydet",
        scale: 0.45
      });

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        pazaryeri: "Ticimax",
        token: Store.state.tokenId
      };
      soap.createClient(url, function(err, client) {
        client.siparisYazToplu(args, function(err, result) {
          if (result.siparisYazTopluResult == "-1") {
            Store.dispatch("logout");
          }
          try {
            vm.veriler = JSON.parse(result.siparisYazTopluResult);

            if (vm.veriler.response == "Ok") {
              vs.loading.close(
                "#button-with-loading-TopluKaydet > .con-vs-loading"
              );
              vs.notify({
                title: "Toplu Sipariş",
                text: "Toplu Siparişler Yazılı",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center"
              });
            } else {
              vs.notify({
                title: "Toplu Sipariş",
                text: "Toplu Siparişler Yazılamadı",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center"
              });
            }
          } catch (error) {
            vs.loading.close(
              "#button-with-loading-TopluKaydet > .con-vs-loading"
            );
            vs.notify({
              title: "Toplu Sipariş",
              text: "Toplu Siparişler Yazılamadı",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center"
            });
          }
        });
      });
    }
  },

  mounted() {
    this.types.forEach(type => {
      this.$vs.loading({
        container: `#loading-${type}`,
        type,
        text: type,
        scale: 0.55
      });
    });
    //tables global olarak tanımlanıyor
    this.$root.$on("xmlTicimaxSiparisListele", () => {
      this.siparisListesi();
    });
  },
  beforeDestroy() {
    this.$root.$off("xmlTicimaxSiparisListele");
  }
};
</script>
<style lang="scss">
@import "@/assets/scss/vuexy/pages/loading.scss";

.mb-base {
  margin-bottom: 0.75rem !important;
}
.list-view-item {
  .item-name,
  .item-description {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .item-name {
    -webkit-line-clamp: 2;
  }

  .item-description {
    -webkit-line-clamp: 5;
  }

  .grid-view-img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    transition: 0.35s;
  }

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.25);

    .grid-view-img {
      opacity: 0.9;
    }
  }
}
[dir] #loading-demo .fill-row-loading .loading-example h4 {
  display: none !important;
}
.con-vs-loading .title-loading {
  display: none !important;
}
</style>
